import script from "./MonthCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthCalendar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__